/*doc

 Displays a widget with Author name, photo, most recent book, Ask button (if they are enabled for
 Ask The Author), and number of answers they've given.

 If an author is not enabled for ATA, the tag and Ask button are both hidden.

 */

import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import UserIcon from "../../user/user_icon";
import { ICON_SIZES } from "../../../modules/shape_icon_values";
import React from "react";

export default GrComponentFactory.createClass({
  displayName: "AskTheAuthorFeaturedAuthorContainer",

  propTypes: {
    authorUser: GrPropTypes.author().isRequired,
    authorTagline: React.PropTypes.string.isRequired,
    ATAenabled: React.PropTypes.bool.isRequired,
    questionURL: React.PropTypes.string.isRequired,
    answerURL: React.PropTypes.string.isRequired,
    answersCount: React.PropTypes.string,
  },

  render() {
    return (
      <div className="gr-mediaFlexbox">
        <div className="gr-mediaFlexbox__media gr-mediaFlexbox__media--verticallyCentered">
          <UserIcon user={{ viewableName: this.props.authorUser.name,
                            profileImage: this.props.authorUser.profileImage,
                            profileUrl: this.props.authorUser.profileUrl }}
                    size={ICON_SIZES.LARGE}/>
        </div>
        <div className="gr-mediaFlexbox__desc">
          <div className="askTheAuthorFeaturedListItemContainer__title">
            <a href={this.props.authorUser.profileUrl}
               className="gr-hyperlink gr-hyperlink--bold">
              {this.props.authorUser.name} </a>
          </div>

          <div>
            <small>
              {this.props.authorTagline}
            </small>
          </div>
          {this.props.ATAenabled ?
            <div className={"askTheAuthorFeaturedListItemContainer__button"}>
            <a href={this.props.questionURL}
               className="gr-button"
               aria-label="Ask {this.props.authorUser.name} a question">
              Ask </a>
            </div>
            : null}
          {this.props.answersCount ?
          <div className="u-inlineBlock">
            <a href={this.props.answerURL}
               className="gr-hyperlink">{this.props.answersCount}</a>
          </div>
            : null}
        </div>
      </div>
    );
  },
});
